import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        players: [],
        games: [],
        locations: [],
        gameStats: {
            games: 0,
            rounds: 0,
            shortGames: 0,
            seasons: {},
            beers: 0
        },
        seasonalResults: {},
        seasonalStats: {},
        currentSeason: 0,
        token: null
      },
    mutations: {
        setPlayers (state, players) {
            state.players = players
        },
        setLocations (state, locations) {
            state.locations = locations
        },
        setGames (state, games) {
            state.games = games
        },
        setGameStats (state, stats) {
            state.gameStats = stats
        },
        setSeasonalResults (state, seasons) {
            state.seasonalResults = seasons
        },
        setSeasonalStats (state, stats) {
            state.seasonalStats = stats
        },
        setCurrentSeason (state, season) {
            state.currentSeason = season
        },
        addGame(state, game){
            state.games.push(game)
        },
        updateGame(state, game){
            let oldGame = state.games.findIndex(item => item.id == game.id)
            console.log("Index", oldGame)
            if(oldGame != -1){
                console.log("Update game")
                state.games[oldGame] = game
            }
        },
        deleteGame(state, id){
            let oldGame = state.games.findIndex(item => item.id == id)
            if(oldGame != -1){
                state.games.splice(oldGame, 1)
            }
        },
        setToken(state, token){
            state.token = token
        }
    },
    getters: {
        sortedPlayers(state){
            return state.players.sort((a, b) => {
                return b.score - a.score
            })
        },
        gameStats(state){
            return state.gameStats
        },
        numberOfGames(state){
            return state.games.length
        },
        allGames(state){
            return state.games
        },
        token(state){
            return state.token
        },
        locations(state){
            return state.locations
        }
    }
  })

  